<template>
    <div class="enrollment-switcher">
        <span v-if="otherEnrollments.length" class="toggle" @click.prevent="showMenu = !showMenu">&hellip;</span>
        <div class="selected-program" v-if="currentEnrollment">                        
            <div class="title">Program</div>
            <div class="program-name" v-if="currentEnrollment.program">
                {{currentEnrollment.program.name}}
            </div>            
            <div class="title">{{currentEnrollment.intake | monthAndYear}} &ndash; {{currentEnrollment.endDate | monthAndYear}}</div>
            <span class="pill">
                {{currentEnrollment.stage}}
            </span>
        </div>

        <div class="menu" v-if="showMenu">
            <ul class="unstyled">
                <li 
                    @click.prevent="switchEnrollments(enrollment.id)"
                    v-for="enrollment in otherEnrollments" 
                    :key="enrollment.id"
                    class="enrollment">
                    <div class="title">Program</div>
                    <div class="program-name">
                        {{enrollment.program.name}}
                    </div>     
                    <div class="title">{{enrollment.intake | monthAndYear}} &ndash; {{enrollment.endDate | monthAndYear}}</div>       
                    <span class="pill">
                        {{enrollment.stage}}
                    </span>
                </li>
            </ul>
        </div>        
         
    </div>
</template>
<script>
import students from '../../services/students';
import auth from '../../services/auth';

export default {
    data() {
        return {
            showMenu: false,            
            selectedEnrollment: null,
        }
    },
    components: {

    },
    created() {
        this.getEnrollments();
        
    },
    mounted() {
        if (localStorage.enrollment) {
            this.selectedEnrollment = parseInt(localStorage.enrollment);            
        }
    },
    methods: {
        getEnrollments() {
            students.getEnrollments().then((response) => {                
                this.$store.dispatch('populate', {
                    type: 'enrollments',
                    data: response.data.enrollments
                });                
            });
        },
        switchEnrollments(enrollmentId) {

            localStorage.enrollment = enrollmentId;

            auth.exchangeJWT(enrollmentId).then((response) => {

                this.$nextTick(() => {
                    if (localStorage.terms.split(',').length > 3) {
                        this.$router.push('/mentor-dashboard');
                    } else {
                        window.location = window.origin;
                    }
                    setTimeout(() => {
                        window.location.reload();
                    }, 500);
                });
            });
        },
    },
    computed: {
        enrollments() {
            return this.$store.getters.enrollments;        
        },
        currentEnrollment() {
            if (this.selectedEnrollment && this.enrollments) {
                return this.enrollments.find(e => e.id === this.selectedEnrollment);
            }
            return [];
        },
        otherEnrollments() {

            if (this.selectedEnrollment && this.enrollments) {
                return this.enrollments.filter(e => e.id !== this.selectedEnrollment);
            }
            return [];
        }

    }
}

</script>
<style lang="scss" scoped>
    .menu {        
        position: absolute;
        background:#111;
        width:100%;
        padding:1rem;
        border:1px solid #4d4d4d;
        top:0;
        left:calc(100% + 8px) ;
        z-index:999900;
    }
    .enrollment-switcher {
        position: relative;
        padding:1rem;
        padding-top: 2rem;
        padding-bottom:3rem;
        margin-bottom:2rem;
        border-top: 1px solid #4D4D4D;
        border-bottom: 1px solid #4D4D4D;
    }
    .toggle {
        position:absolute;
        top:0;
        right:0;
        color:#fff;
        cursor: pointer;
        font-size:18px;
        user-select: none;
    }
    .title {
        color: #B3B3B3;
        font-weight: 600;
        text-transform: uppercase;
        font-size: 12px;
        margin-bottom: 1rem;
    }

    .program-name {
        color: #fff;
        font-weight: 700;
        margin-bottom: 1rem;
    }

    .pill {
        color: #181818;
        background: #3cf;
        padding: 4px 8px;
        border-radius: 4px;
        font-weight: 600;
        text-transform: uppercase;
        font-size: 12px;
    }

    li.enrollment {
        margin-bottom: 2rem;
        cursor: pointer;
    }

</style>



// WEBPACK FOOTER //
// EnrollmentSelector.vue?496321f6